import React from "react"

import "./ChooseATemplateComponent.css"
import ShowTemplatesComponent from "components/Broadcast/ShowTemplatesComponent"
import StepperComponent from "components/Broadcast/StepperComponent"

function ChooseATemplateComponent({
  step,
  setStep,
  data,
  setData,
  singleTemplateData,
  setSingleTemplateData,
}) {
  return (
    <div className="steps-page-layout my-auto px-3">
      <div className="stepper-wrapper">
        <StepperComponent step={step} />
      </div>

      <div>
        <ShowTemplatesComponent
          setStep={setStep}
          data={data}
          setData={setData}
          singleTemplateData={singleTemplateData}
          setSingleTemplateData={setSingleTemplateData}
        />
      </div>
    </div>
  )
}

export default ChooseATemplateComponent
